import { render, staticRenderFns } from "./CalendarWrapper.vue?vue&type=template&id=01218a68&"
import script from "./CalendarWrapper.vue?vue&type=script&lang=js&"
export * from "./CalendarWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports